import { render, staticRenderFns } from "./userLoginLog.vue?vue&type=template&id=bfbb87aa&scoped=true&"
import script from "./userLoginLog.vue?vue&type=script&lang=js&"
export * from "./userLoginLog.vue?vue&type=script&lang=js&"
import style0 from "./userLoginLog.vue?vue&type=style&index=0&id=bfbb87aa&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfbb87aa",
  null
  
)

export default component.exports